// [ISSUE-D1 2026-07] Extract a human, localized message from an axios error.
//
// FastAPI error `detail` comes in three shapes across this app:
//   - a plain string (most HTTPException raises)
//   - a Pydantic 422 validation array: [{ msg, loc, ... }, ...]
//   - a localized object, e.g. the YEAR_LOCKED / SUBSCRIPTION_REQUIRED locks:
//       { code, message, message_fr, message_en, ... }
// This picks the right one, honouring the current UI language for the object
// form, and falls back to a caller-supplied default.
import i18n from '../i18n';
import { localizedServerMessage } from './sessionEvents';
import { translateServerMessage } from './serverMessages';

export function apiErrorMessage(error, fallback = '') {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback || (error?.message ?? '');

  // [AUDIT-2026-10-28 M-OPEN-1] Most backend errors are one English (or one
  // Arabic) string: show it in the UI's language when the catalog knows it.
  if (typeof detail === 'string') return translateServerMessage(detail, i18n.language);

  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => (d && d.msg) || '').filter(Boolean);
    return msgs.length ? msgs.join(' | ') : fallback;
  }

  if (typeof detail === 'object') {
    // The UI language's message; Arabic (or anything else) → the primary
    // `message`, then any localized one.
    return localizedServerMessage(detail, i18n.language) || fallback;
  }

  return fallback;
}

export default apiErrorMessage;
